import "core-js/modules/es.function.name";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { chooseWXPay } from '@/lib/script/pay';
var m = {
  namespaced: true,
  state: function state() {
    return {
      graduationInfo: null
    };
  },
  mutations: {
    setGraduationInfo: function setGraduationInfo(state, graduationInfo) {
      state.graduationInfo = graduationInfo;
    }
  },
  actions: {
    /**
     * 获取报名毕业跑的信息
     */
    getGraduationInfo: function getGraduationInfo(_a, forceUpdate) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (state.graduationInfo && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/graduation/order')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setGraduationInfo', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 保存个人信息
     * @param name 姓名
     * @param mobile 手机号
     * @param certificateType 证件类型
     * @param id 证件号
     * @param gender 性别
     * @param bloodType 血型
     * @param size 衣服尺码
     * @param emergencyContact 紧急联系人
     * @param emergencyContactMobile 紧急联系电话
     * @param referrer 推荐人
     */
    saveUserInfo: function saveUserInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var name = _b.name,
          mobile = _b.mobile,
          certificateType = _b.certificateType,
          id = _b.id,
          gender = _b.gender,
          bloodType = _b.bloodType,
          size = _b.size,
          emergencyContact = _b.emergencyContact,
          emergencyContactMobile = _b.emergencyContactMobile,
          referrer = _b.referrer;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/graduation/user_info', {
                name: name,
                mobile: mobile,
                id_type: certificateType,
                id_number: id,
                sex: gender,
                blood_type: bloodType,
                clothing_size: size,
                emergency_contact: emergencyContact,
                emergency_contact_mobile: emergencyContactMobile,
                referrer: referrer
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 下单报名参加毕业跑
     */
    createOrder: function createOrder(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var orderResponse, orderRdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/graduation/order')];

            case 1:
              orderResponse = _b.sent();
              orderRdata = orderResponse.data;
              return [2
              /*return*/
              , orderRdata];
          }
        });
      });
    },

    /**
     * 支付
     *
     * @param {} orderId 订单号
     * @return {} rdata
     */
    pay: function pay(context, orderId) {
      return __awaiter(this, void 0, void 0, function () {
        var payResponse, payRdata, ret;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/graduation/pay', {
                order_id: orderId
              })];

            case 1:
              payResponse = _a.sent();
              payRdata = payResponse.data;
              return [4
              /*yield*/
              , chooseWXPay(payRdata.data.params)];

            case 2:
              ret = _a.sent();
              ret.type = 'jsapi';
              ret.orderId = orderId;
              return [2
              /*return*/
              , ret];
          }
        });
      });
    },

    /**
     * 支付状态检查
     *
     * @param {} orderId 订单号
     * @return {} rdata
     */
    payStatus: function payStatus(context, orderId) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/graduation/order_status', {
                params: {
                  order_id: orderId
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;